import { useAuth } from '@teko/auth-react';
import { useTenantConfig } from 'contexts';
import TerraKit from '@terra-js/terra-kit';

export const useRequireLoginForCartAction = () => {
  const { user, authService } = useAuth();
  const { epicOmni1825 } = useTenantConfig();

  return () => {
    if (TerraKit.isAvailable()) {
      if (!TerraKit.auth().getAccessToken()) {
        TerraKit.auth().loginWithIamToken();
        return true;
      }

      return false;
    }

    if (!!epicOmni1825 && !user?.userId) {
      authService.login(window.location.href);
      return true;
    }
    return false;
  };
};
